import React from 'react'
import {
  Select,
  Input,
  Form,
  Button,
  Divider,
  message,
  Tabs,
  DatePicker,
  Steps,
  Popconfirm, Modal
} from 'antd'
import { ajaxApi} from '../../../server/index'
import { getParmUrl } from '../../../public/utils'
import 'moment/locale/zh-cn'
import _lodash from 'lodash'
import common from '@/public/common'
import styles from './commodity-management-add.module.less'
const Option = Select.Option
const TabPane = Tabs.TabPane
const { RangePicker } = DatePicker
const { Step } = Steps
class BasicInformation extends React.Component {
  constructor (props) {
    super(props)
    this.state = {
      addData: null,
      propertyData: [],
      categoryArr: [],
      brandArr: [],
      skuVal: '',
      skuType: '',
      skuVisible: false
    }
  }

  componentDidMount () {
    let { addData } = this.state
    addData = JSON.parse(sessionStorage.getItem('addData'))
    this.setState(
      {
        addData
      },
      () => {
        if (!getParmUrl('id')) {
          this.getQueryProperty()
        }
      }
    )
    this.getQueryCategory()
    this.getQueryBrand()
  }

  componentWillReceiveProps (nextprops) {
    let { addData } = this.state
    addData = JSON.parse(sessionStorage.getItem('addData'))
    this.setState(
      {
        addData
      },
      () => {
        // console.log(this.state.addData)
        if (!getParmUrl('id')) {
          // this.getQueryProperty();
        }
      }
    )
  }

  // 查询品牌
  getQueryBrand = async () => {
    let {brandArr} = this.state
    try {
      let res = await ajaxApi({
        url: common.scpUrl + 'item/query-brand',
        params: {}
      })
      if (res.status === 200 && res.data) {
        this.setState({
          brandArr: res.data.data
        })
      } else {
        this.setState({
          brandArr: []
        })
      }
    } catch (e) {
      console.log(e)
    }
  }

  // 查询类别
  getQueryCategory = async () => {
    let { categoryArr } = this.state
    try {
      let res = await ajaxApi({
        url: common.scpUrl + 'item/query-category',
        params: {}
      })
      if (res.status === 200 && res.data) {
        this.setState({
          categoryArr: res.data.data
        })
      } else {
        this.setState({
          categoryArr: []
        })
      }
    } catch (e) {
      console.log(e)
    }
  };

  // 获取 属性和sku
  getQueryProperty = async () => {
    let { addData } = this.state
    try {
      let _params = {
        category_id: addData.item_info.category_id
      }
      let res = await ajaxApi({
        url: common.scpUrl + 'item/query-property',
        params: _params
      })
      if (res.status === 200 && res.data) {
        let _data = res.data.data
        if (_data.length !== 0) {
          if (
            addData.extend_propertys.length === 0 &&
            addData.sku_propertys.length === 0
          ) {
            _lodash.forEach(_data, (item, index) => {
              if (item.property_type === 'Extend') {
                addData.extend_propertys.push({
                  property_id: item.property_id,
                  property_name: item.property_name,
                  sku_value: item.property_value ? item.property_value : [''],
                  property_type: item.property_type,
                  is_required: item.is_required
                })
              } else {
                addData.sku_propertys.push({
                  property_id: item.property_id,
                  property_name: item.property_name,
                  sku_value: item.property_value ? item.property_value : [],
                  property_type: item.property_type,
                  is_required: item.is_required
                })
              }
            })
          }
        }

        this.setState(
          {
            propertyData: res.data.data,
            addData
          },
          () => {
            console.log(this.state.addData)
            sessionStorage.setItem('addData', JSON.stringify(this.state.addData))
          }
        )
      }
    } catch (e) {
      console.log(e)
    }
  };

  // 获取输入框的值
  handleChangeInput = (e, name) => {
    let { addData } = this.state
    addData.item_info[name] = e.target.value
    this.setState(
      {
        addData
      },
      () => {
        sessionStorage.setItem('addData', JSON.stringify(this.state.addData))
      }
    )
  };

  // 获取Extend输入框的值
  handleChangeInputExtend = (e, index) => {
    let { addData } = this.state
    addData.extend_propertys[index].extend_value = e.target.value
    this.setState(
      {
        addData
      },
      () => {
        sessionStorage.setItem('addData', JSON.stringify(this.state.addData))
      }
    )
  };

  // 获取Extend下拉框的值
  handleChangeSelectExtend=(e, index) => {
    let { addData } = this.state
    addData.extend_propertys[index].extend_value = e
    this.setState(
      {
        addData
      },
      () => {
        sessionStorage.setItem('addData', JSON.stringify(this.state.addData))
      }
    )
  }

  // 获取下拉框的值
  handelChangeSource=(e, name) => {
    let { addData, brandArr } = this.state
    addData.item_info[name] = e
    if (name === 'brand_id') {
      _lodash.forEach(brandArr, (item, index) => {
        if (e === item.id) {
          addData.item_info.brand_name = item.name
        }
      })
    }
    this.setState(
      {
        addData
      },
      () => {
        sessionStorage.setItem('addData', JSON.stringify(this.state.addData))
      }
    )
  }

  // 获取Sku输入框的值
  handleChangeInputSku=(e, index, name) => {
    let {addData} = this.state
    // addData.sku_propertys[index].sku_value[index2] = e.target.value
    this.setState({
      // addData
      skuVal: e.target.value,
      skuType: name
    }, () => {
      // sessionStorage.setItem('addData', JSON.stringify(this.state.addData))
    })
  }

    // sku添加
    handleSkuAdd=(e, index, name) => {
      let { addData, skuType, skuVal } = this.state
      // addData.sku_propertys[index].sku_value.push('')
      if (name === skuType) {
        if (skuVal === '') {
          message.warning('请填写要添加的SKU属性值')
        } else {
          addData.sku_propertys[index].sku_value.push(skuVal)
          addData.sku_propertys[index].sku_value = _lodash.uniqWith(addData.sku_propertys[index].sku_value, _lodash.isEqual)
          skuVal = ''
        }
      } else {
        message.warning('请填写要添加的SKU属性值')
      }
      this.setState({
        addData,
        skuVal
      }, () => {
        console.log(this.state.addData)
        sessionStorage.setItem('addData', JSON.stringify(this.state.addData))
      })
    }

    // sku光度选择添加
    handleSkuSelectAdd=(e, index, name) => {
      let { addData, skuType, skuVal } = this.state
      this.setState({
        skuVisible: true,
        skuIndex: index
      })
    }

    // sku光度快捷添加
    handleSkuQuickAdd=(e, type) => {
      let { addData, skuIndex } = this.state
      let _skuArrMin = ['0.00', '-1.00', '-1.25', '-1.50', '-1.75', '-2.00', '-2.25', '-2.50', '-2.75', '-3.00', '-3.25', '-3.50', '-3.75', '-4.00', '-4.25', '-4.50', '-4.75', '-5.00', '-5.25', '-5.50', '-5.75', '-6.00', '-6.50', '-7.00', '-7.50', '-8.00']
      let _skuArrMax = ['0.00', '-1.00', '-1.25', '-1.50', '-1.75', '-2.00', '-2.25', '-2.50', '-2.75', '-3.00', '-3.25', '-3.50', '-3.75', '-4.00', '-4.25', '-4.50', '-4.75', '-5.00', '-5.25', '-5.50', '-5.75', '-6.00', '-6.50', '-7.00', '-7.50', '-8.00', '-8.50', '-9.00', '-9.50', '-10.00', '-10.50', '-11.00', '-11.50', '-12.00']
      if (type === 'Y-1.00-0.25-6.00-0.50-8.00') {
        _skuArrMin.map(item => {
          addData.sku_propertys[skuIndex].sku_value.push(item)
        })
      } else {
        _skuArrMax.map(item => {
          addData.sku_propertys[skuIndex].sku_value.push(item)
        })
      }
      addData.sku_propertys[skuIndex].sku_value = _lodash.uniqWith(addData.sku_propertys[skuIndex].sku_value, _lodash.isEqual)
      this.setState({
        addData,
        skuVisible: false
      }, () => {
        console.log(this.state.addData)
        sessionStorage.setItem('addData', JSON.stringify(this.state.addData))
      })
    }

    // sku删除
    handledelete=(e, index, index2) => {
      let { addData } = this.state
      addData.sku_propertys[index].sku_value.splice(index2, 1)
      this.setState({
        addData
      }, () => {
        sessionStorage.setItem('addData', JSON.stringify(this.state.addData))
      })
    }

    // 弹框隐藏
    handleCancel=() => {
      this.setState({
        skuVisible: false
      })
    }

  // 下一步
  handleNext = () => {
    let { addData } = this.state
    sessionStorage.setItem('addData', JSON.stringify(addData))
    this.props.getCurrent(1)
  };

  //  上一步
  handleBack = () => {
    let { addData } = this.state
    sessionStorage.setItem('addData', JSON.stringify(addData))
    sessionStorage.setItem('current', 0)
  };

  render () {
    let { propertyData, addData, categoryArr } = this.state
    return (
      <div>
        <div style={{ display: 'flex', border: '1px solid #d9d9d9' }}>
          {/* <div style={{width: '15%', borderRight: '1px solid #d9d9d9'}}>
            <div className={styles.informationtitle} style={{marginTop: '8%'}}>基础信息</div>
            <div className={styles.informationtitle} style={{marginTop: '130%'}}>扩展信息</div>
            <div className={styles.informationtitle}>SKU</div>
    </div> */}
          <div style={{ width: '100%' }}>
            <div
              style={{
                paddingLeft: '17%',
                marginTop: '24px',
                fontSize: '16px'
              }}
            >
              <span className={styles.titles}>基础信息</span>
            </div>
            <div
              style={{
                display: 'flex',
                flexWrap: 'wrap',
                width: '100%',
                paddingLeft: '13%'
              }}
            >
              <section className={styles.publicsection}>
                <span className={styles.publlictitle}>
                  <span className={styles.required}>*</span>商品名称：
                </span>
                <Input
                  onKeyDown={this.onKeyup}
                  value={addData ? addData.item_info.item_name : ''}
                  placeholder="请输入"
                  name="item_name"
                  onChange={(e) => this.handleChangeInput(e, 'item_name')}
                  style={{ width: 244, marginRight: '0px' }}
                />
              </section>

              <section className={styles.publicsection}>
                <span className={styles.publlictitle}>
                  <span className={styles.required}>*</span>商品品牌：
                </span>
                <Select
                  showSearch
                  // mode="multiple"
                  onKeyDown={this.onKeyup}
                  style={{ width: 244, marginRight: '0px' }}
                  optionFilterProp="children"
                  placeholder='请选择'
                  value={addData ? addData.item_info.brand_id : ''}
                  onChange={(e) => this.handelChangeSource(e, 'brand_id')}
                >
                  <Option key={0} name='brand_id' value=''>请选择</Option>
                  {this.state.brandArr || this.state.brandArr.length === 0 ? this.state.brandArr.map((item, index) => (
                    <Option key={index + 1} name='brand_id' value={item.id}>{item.name}</Option>
                  )) : null}
                </Select>
              </section>

              <section className={styles.publicsection}>
                <span className={styles.publlictitle}>
                  <span className={styles.required}></span>商品类别：
                </span>
                <Select
                  showSearch
                  // mode="multiple"
                  onKeyDown={this.onKeyup}
                  disabled
                  style={{ width: 244, marginRight: '0px' }}
                  optionFilterProp="children"
                  placeholder='请选择'
                  value={addData ? addData.item_info.category_id : ''}
                  onChange={(e) => this.handelChangeSource(e, 'category_id')}
                >
                  <Option key={0} name='category_id' value=''>请选择</Option>
                  {(this.state.categoryArr || this.state.categoryArr.length === 0) ? this.state.categoryArr.map((item, index) => (
                    <Option key={index + 1} name='category_id' value={item.id}>{item.name}</Option>
                  )) : null}
                </Select>
              </section>

              <section className={styles.publicsection}>
                <span className={styles.publlictitle}>
                  <span className={styles.required}>*</span>规格型号：
                </span>
                <Input
                  onKeyDown={this.onKeyup}
                  placeholder="请输入"
                  name="spec_type"
                  value={addData ? addData.item_info.spec_type : ''}
                  onChange={(e) => this.handleChangeInput(e, 'spec_type')}
                  style={{ width: 244, marginRight: '0px' }}
                />
              </section>

              <section className={styles.publicsection}>
                <span className={styles.publlictitle}>
                  <span className={styles.required}>*</span>成分：
                </span>
                <Input
                  onKeyDown={this.onKeyup}
                  placeholder="请输入"
                  name="element"
                  value={addData ? addData.item_info.element : ''}
                  onChange={(e) => this.handleChangeInput(e, 'element')}
                  style={{ width: 244, marginRight: '0px' }}
                />
              </section>

              <section className={styles.publicsection}>
                <span className={styles.publlictitle}>
                  <span className={styles.required}></span>有效期：
                </span>
                <Input
                  onKeyDown={this.onKeyup}
                  addonAfter="年"
                  // onkeyup="value=value.replace(/[^0-9]/g,'')"
                  // onpaste="value=value.replace(/[^0-9]/g,'')"
                  // oncontextmenu="value=value.replace(/[^0-9]/g,'')"
                  placeholder="请输入"
                  value={addData ? addData.item_info.item_useful_life : ''}
                  name="item_useful_life"
                  onChange={(e) =>
                    this.handleChangeInput(e, 'item_useful_life')
                  }
                  style={{ width: 244, marginRight: '0px' }}
                />
              </section>

              <section className={styles.publicsection}>
                <span className={styles.publlictitle}>
                  <span className={styles.required}>*</span>生产企业：
                </span>
                <Input
                  onKeyDown={this.onKeyup}
                  placeholder="请输入"
                  name="create_company"
                  value={addData ? addData.item_info.create_company : ''}
                  onChange={(e) => this.handleChangeInput(e, 'create_company')}
                  style={{ width: 244, marginRight: '0px' }}
                />
              </section>

              <section className={styles.publicsection}>
                <span className={styles.publlictitle}>
                  <span className={styles.required}></span>产品注册证号：
                </span>
                <Input
                  onKeyDown={this.onKeyup}
                  placeholder="请输入"
                  name="regist_number"
                  value={addData ? addData.item_info.regist_number : ''}
                  onChange={(e) => this.handleChangeInput(e, 'regist_number')}
                  style={{ width: 244, marginRight: '0px' }}
                />
              </section>

              <section className={styles.publicsection}>
                <span className={styles.publlictitle}>
                  <span className={styles.required}>*</span>产地：
                </span>
                <Input
                  onKeyDown={this.onKeyup}
                  placeholder="请输入"
                  name="origin_place"
                  value={addData ? addData.item_info.origin_place : ''}
                  onChange={(e) => this.handleChangeInput(e, 'origin_place')}
                  style={{ width: 244, marginRight: '0px' }}
                />
              </section>

              <section className={styles.publicsection}>
                <span className={styles.publlictitle}>
                  <span className={styles.required}></span>注册证有效期：
                </span>
                <Input
                  onKeyDown={this.onKeyup}
                  addonAfter="年"
                  placeholder="请输入"
                  value={addData ? addData.item_info.regist_useful_life : ''}
                  name="regist_useful_life"
                  onChange={(e) =>
                    this.handleChangeInput(e, 'regist_useful_life')
                  }
                  style={{ width: 244, marginRight: '0px' }}
                />
              </section>
            </div>

            <div
              style={{
                paddingLeft: '17%',
                marginTop: '64px',
                fontSize: '16px',
                display: addData
                  ? addData.extend_propertys.length !== 0
                    ? 'block'
                    : 'none'
                  : 'none'
              }}
            >
              <span className={styles.titles}>扩展信息</span>
            </div>
            <div
              style={{
                display: 'flex',
                flexWrap: 'wrap',
                width: '100%',
                position: 'relative',
                paddingLeft: '13%'
              }}
            >
              {addData
                ? addData.extend_propertys ||
                  addData.extend_propertys.length !== 0
                  ? addData.extend_propertys.map((item, index) => {
                    if (item.property_type === 'Extend') {
                      return (
                        <section className={styles.publicsection}>
                          <span className={styles.publlictitle}>
                            <span
                              className={styles.required}
                              style={{
                                display:
                                    item.is_required === 1
                                      ? 'inline-block'
                                      : 'none'
                              }}
                            >
                                *
                            </span>
                            {item.property_name}：
                          </span>
                          {item.property_name === '更换周期' ? (
                            <Select
                              showSearch
                              // mode="multiple"
                              onKeyDown={this.onKeyup}
                              style={{ width: 244, marginRight: '0px' }}
                              optionFilterProp="children"
                              placeholder='请选择'
                              value={item.extend_value}
                              onChange={(e) => this.handleChangeSelectExtend(e, index)}
                            >
                              <Option key={0} value=''>请选择</Option>
                              <Option key={1} value='日抛'>日抛</Option>
                              <Option key={2} value='周抛'>周抛</Option>
                              <Option key={3} value='月抛'>月抛</Option>
                              <Option key={4} value='半年抛'>半年抛</Option>
                              <Option key={4} value='年抛'>年抛</Option>
                            </Select>
                          ) : item.property_name === '是否高散光高度数' ? (

                            <Select
                              showSearch
                              // mode="multiple"
                              onKeyDown={this.onKeyup}
                              style={{ width: 244, marginRight: '0px' }}
                              optionFilterProp="children"
                              placeholder='请选择'
                              value={item.extend_value}
                              onChange={(e) => this.handleChangeSelectExtend(e, index)}
                            >
                              <Option key={0} value={null}>请选择</Option>
                              <Option key={1} value={1}>是</Option>
                              <Option key={2} value={0}>否</Option>

                            </Select>
                          ) : item.property_name === 'ContactsType' ? (
                            <Select
                              showSearch
                              // mode="multiple"
                              onKeyDown={this.onKeyup}
                              style={{ width: 244, marginRight: '0px' }}
                              optionFilterProp="children"
                              placeholder='请选择'
                              value={item.extend_value}
                              onChange={(e) => this.handleChangeSelectExtend(e, index)}
                            >
                              <Option key={0} value='普通隐形眼镜'>普通隐形眼镜</Option>
                              <Option key={1} value='彩色隐形眼镜'>彩色隐形眼镜</Option>
                            </Select>
                          ) : item.property_name === '是否支持渐近多焦' ? (
                            <Select
                              showSearch
                              // mode="multiple"
                              onKeyDown={this.onKeyup}
                              style={{ width: 244, marginRight: '0px' }}
                              optionFilterProp="children"
                              placeholder='请选择'
                              value={item.extend_value}
                              onChange={(e) => this.handleChangeSelectExtend(e, index)}
                            >
                              <Option key={0} value={null}>请选择</Option>
                              <Option key={1} value={1}>是</Option>
                              <Option key={2} value={0}>否</Option>
                            </Select>
                          ) : item.property_name === '材质是否支持记忆功能' ? (
                            <Select
                              showSearch
                              // mode="multiple"
                              onKeyDown={this.onKeyup}
                              style={{ width: 244, marginRight: '0px' }}
                              optionFilterProp="children"
                              placeholder='请选择'
                              value={item.extend_value}
                              onChange={(e) => this.handleChangeSelectExtend(e, index)}
                            >
                              <Option key={0} value={null}>请选择</Option>
                              <Option key={1} value={1}>是</Option>
                              <Option key={2} value={0}>否</Option>
                            </Select>
                          ) : item.property_name === '抗UV' ? (
                            <Select
                              showSearch
                              // mode="multiple"
                              onKeyDown={this.onKeyup}
                              style={{ width: 244, marginRight: '0px' }}
                              optionFilterProp="children"
                              placeholder='请选择'
                              value={item.extend_value}
                              onChange={(e) => this.handleChangeSelectExtend(e, index)}
                            >
                              <Option key={0} value={null}>请选择</Option>
                              <Option key={1} value={1}>是</Option>
                              <Option key={2} value={0}>否</Option>
                            </Select>
                          )
                            : (<Input onKeyDown={this.onKeyup}
                              placeholder="请输入"
                              value={item.extend_value}

                              onChange={(e) =>
                                this.handleChangeInputExtend(e, index)
                              }
                              style={{ width: 244, marginRight: '0px' }}
                            />)}

                        </section>
                      )
                    }
                  })
                  : null
                : null}
            </div>

            <div
              style={{
                paddingLeft: '17%',
                marginTop: '64px',
                fontSize: '16px',
                display: addData
                  ? addData.sku_propertys.length !== 0
                    ? 'block'
                    : 'none'
                  : 'none'
              }}
            >
              <span className={styles.titles}>SKU</span>
            </div>
            <div
              style={{
                display: 'flex',
                flexWrap: 'wrap',
                width: '100%',
                position: 'relative',
                paddingLeft: '13%'
              }}
            >
              {addData
                ? addData.sku_propertys || addData.sku_propertys.length !== 0
                  ? addData.sku_propertys.map((item, index) => {
                    if (item.property_type === 'SKU') {
                      if (item.property_name !== '光度') {
                        return (
                          <section key ={index} className={styles.publicsection}>
                            <span className={styles.publlictitle}><span className={styles.required} style={{display: item.is_required === 1 ? 'inline-block' : 'none'}}>*</span>{item.property_name}：</span>
                            <Input
                              onKeyDown={this.onKeyup}
                              placeholder="请输入"
                              value={this.state.skuType === item.property_name ? this.state.skuVal : ''}
                              onChange={(e) =>
                                this.handleChangeInputSku(e, index, item.property_name)
                              }
                              style={{ width: 244, marginRight: '0px', marginBottom: '12px' }}/>
                            <a style={{marginLeft: 4}} onClick={(e) => this.handleSkuAdd(e, index, item.property_name)}>手动添加</a>
                            <div style={{display: 'flex', width: '250px', flexWrap: 'wrap', marginLeft: 136}}>
                              {item.sku_value ? (
                                item.sku_value.length !== 0 ? (
                                  item.sku_value.map((item2, index2) => {
                                    return (
                                      <span>
                                        <Popconfirm title="确定要删除吗？" onConfirm={(e) => this.handledelete(e, index, index2)} okText="确定" cancelText="取消">
                                          <a style={{marginRight: '8px'}}>{item2}</a>
                                        </Popconfirm>
                                      </span>

                                    )
                                  })
                                ) : null
                              ) : null}
                            </div>
                          </section>
                        )
                      } else {
                        return (
                          <section key ={index} className={styles.publicsection}>
                            <span className={styles.publlictitle}><span className={styles.required} style={{display: item.is_required === 1 ? 'inline-block' : 'none'}}>*</span>{item.property_name}：</span>
                            <Input
                              onKeyDown={this.onKeyup}
                              placeholder="请输入"
                              value={this.state.skuType === item.property_name ? this.state.skuVal : ''}
                              onChange={(e) =>
                                this.handleChangeInputSku(e, index, item.property_name)
                              }
                              style={{ width: 244, marginRight: '0px', marginBottom: '12px' }}/>
                            <a style={{marginLeft: 4}} onClick={(e) => this.handleSkuAdd(e, index, item.property_name)}>手动添加</a>
                            <a style={{marginLeft: 4}} onClick={(e) => this.handleSkuSelectAdd(e, index, item.property_name)}>选择添加</a>
                            <div style={{display: 'flex', width: '250px', flexWrap: 'wrap', marginLeft: 136}}>
                              {item.sku_value ? (
                                item.sku_value.length !== 0 ? (
                                  item.sku_value.map((item2, index2) => {
                                    return (
                                      <span>
                                        <Popconfirm title="确定要删除吗？" onConfirm={(e) => this.handledelete(e, index, index2)} okText="确定" cancelText="取消">
                                          <a style={{marginRight: '8px'}}>{item2}</a>
                                        </Popconfirm>

                                      </span>
                                    )
                                  })
                                ) : null
                              ) : null}
                            </div>
                          </section>
                        )
                      }
                    }
                  })
                  : null
                : null}
            </div>

            <div
              style={{
                width: '100%',
                marginBottom: '24px',
                marginTop: '56px',
                textAlign: 'center'
              }}
            >
              <Button
                type=""
                style={{ margin: '0px 8px' }}
                onClick={this.handleNext}
                shape="round"
              >
                下一步
              </Button>
            </div>

            <Modal
              title='选择要添加的SKU属性值'
              visible={this.state.skuVisible}
              onOk={this.handleOk}
              width={700}
              onCancel={this.handleCancel}
              footer={false}
            >
              <div style={{color: '#00f'}}>光度值规则：是否平光(Y/N)-起始度数(1.00)-起跳幅度(0.25)-结束度数(3.00)-二次起幅度(0.50)-二次起跳结束度数(5.00) ...</div>
              <div style={{display: 'flex', flexWrap: 'wrap', justifyContent: 'space-around', margin: '24px 0px'}}>
                <span onClick={(e) => this.handleSkuQuickAdd(e, 'Y-1.00-0.25-6.00-0.50-8.00')} className={styles.skustyle}>Y-1.00-0.25-6.00-0.50-8.00</span>
                <span onClick={(e) => this.handleSkuQuickAdd(e, 'Y-1.00-0.25-6.00-0.50-12.00')} className={styles.skustyle}>Y-1.00-0.25-6.00-0.50-12.00</span>
              </div>
              <div style={{textAlign: 'center'}}>1/1页(共2条记录/每页显示15条)</div>
            </Modal>

          </div>
        </div>
      </div>
    )
  }
}
export default BasicInformation



// WEBPACK FOOTER //
// ./src/pages/commoditymanagement/commoditymanagementadd/basic-information.js